import React, { forwardRef } from 'react';
import { FieldTypes, urlRegexValidator } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import NowSecureMappingForm from './NowSecureMappingForm';

const NowSecureCredentialsForm = forwardRef((props, ref) => {
    const fields = [
        {
            name: "apiEndpoint",
            label: "NowSecure Endpoint",
            rules: [{
                required: true,
                message: "Endpoint is required"
            }, urlRegexValidator()]
        },
        {
            name: "token",
            label: "Token",
            required: true,
            type: FieldTypes.PASSWORD,
        }
    ];
    return (
        <GenericPullCredentialsForm 
         {...props} 
         ref={ref}
         fields={fields}
         MappingForm={NowSecureMappingForm}
         initialValue={{ apiEndpoint: 'https://lab-api.nowsecure.com' }}
          />
    )
});

export default NowSecureCredentialsForm;